export default {"src":"/_next/static/media/secoda.c127824d.svg","height":23,"width":135};